
import './style.scss'
import { formatDate, getSortIcon, handleFilters } from 'utils/common-functions';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { _Object, showTostify } from 'utils/interfaces';
import CustomToast from 'views/components/form-inputs/alert';
import { Skeleton } from 'primereact/skeleton';
import { useFormik } from 'formik';
import { quicklinkService } from 'services';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useEffect, useRef, useState } from 'react';
import { SEOHeader } from 'views/components';
import { InputText } from 'primereact/inputtext';
import { routes } from 'utils/routes';
import { Paginator } from 'primereact/paginator';
import DeleteItem from 'views/components/delete-modal';
import { Button } from 'primereact/button';


const Quicklinks = () => {
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type');
  const navigate = useNavigate();
  const toastRef = useRef<any>(null);

  const [loading, setLoading] = useState(true);
  const [pagination, setPagination] = useState<_Object>({})
  const [quicklinkList, setQuicklinkList] = useState<any>([]);
  const [visible, setVisible] = useState(null);

  const [filterData, setFilterData] = useState<_Object>({
    page: 1,
    per_page: 10,
    q: "",
    sort: '-created_at',
    filter: {
      type: type
    }
  })

  const getQuicklinks = async () => {
    console.log('filterData', filterData);

    try {
      setLoading(true);
      const data = await quicklinkService.getQuicklinks(filterData);
      setQuicklinkList(data.items);
      setPagination(data.pagination);
    } catch (error) {
      console.error('Error fetching employees:', error);
    } finally {
      setLoading(false);
    }
  };

  const deleteItem = async (itemToDelete: null) => {
    if (!itemToDelete) return;
    try {
      setLoading(true);
      const response = await quicklinkService.deleteQuicklink(itemToDelete);
      if (!response.error) {
        showTostify(toastRef, 'success', response.message);
        await getQuicklinks();
        setVisible(null); // Close the modal here
      }
    } catch (error: any) {
      showTostify(toastRef, 'error', error.message);
      console.error('Error deleting employee:', error);
    } finally {
      setLoading(false);
    }
  };

  const onPageChange = (event: any) => {
    const currentPage = Math.floor(event.first / event.rows) + 1;

    setFilterData((prev) => ({
      ...prev,
      page: currentPage,
      per_page: event.rows,
    }));
  };

  useEffect(() => {
    if (filterData.filter?.type) getQuicklinks();
  }, [filterData]);

  useEffect(() => {
    if (type) {
      setFilterData((prev) => ({
        ...prev,
        q: '',
        page: 1,
        filter: {
          type: type
        }
      }));
    }
  }, [type]);

  const formikFilter = useFormik({
    initialValues: filterData,
    enableReinitialize: true,
    onSubmit: (values: _Object) => {
      setFilterData((prev) => ({
        ...prev,
        q: values.q.trim(),
        page: 1
      }));
    }
  });

  return (
    <>
      <SEOHeader title="Quicklinks" />

      <div className="quicklinks-page">
        <CustomToast ref={toastRef} />
        <div className="flex justify-content-between align-items-center">
          <div className="p-inputgroup search-bar col-6">
            <form onSubmit={formikFilter.handleSubmit}>
              <div className='form-group mb-0 mr-2'>
                <Button type='submit' className='search-loading bg-transparent p-0 border-none'
                  disabled={loading}>
                  {loading && <i className="pi pi-spin pi-spinner"
                    style={{ fontSize: '1rem' }}
                  >
                  </i>}
                </Button>

                <IconField iconPosition="left">
                  <InputIcon className="pi pi-search"> </InputIcon>
                  <InputText placeholder="Search"
                    name='q'
                    onChange={formikFilter.handleChange}
                    onBlur={formikFilter.handleBlur}
                    value={formikFilter.values.q} />
                </IconField>

                {filterData.q && <Button type='button'
                  onClick={() => {
                    setFilterData((prev) => ({
                      ...prev,
                      q: '',
                      page: 1
                    }))
                  }}
                  severity="secondary" text className='bg-transparent p-0 border-none absolute top-0 right-0 mr-3'>
                  <span className="pi pi-times "> </span>
                </Button>}
              </div>
            </form>

            {pagination?.total_items > 0 &&
              <div className='total-items flex align-items-center text-sm'>
                Total items: {pagination.total_items || ""}
              </div>
            }
          </div>

          <div className="col-4 text-right">
            <Button label="Add New Quicklinks" icon="pi pi-plus" className="primary" onClick={() => navigate(`${routes.quicklinks}/create?type=${type}`)} />
          </div>
        </div>

        <div className="col">
          <div className="card">
            <table className='w-full'>
              <thead>
                <tr>
                  <th>#</th>
                  <th>Title</th>
                  <th>Brand Name</th>
                  <th>Offer Price</th>
                  <th>Regular Price</th>
                  <th>Description</th>
                  <th>Type</th>
                  <th>
                    <button
                      className="btn p-0 border-0"
                      onClick={() => { handleFilters('sort', filterData.sort === '-created_at' ? 'created_at' : '-created_at', setFilterData) }}>
                      Created At
                      <i className={`pi ${getSortIcon(filterData.sort.includes('created_at') ? filterData.sort : '')}`}></i>
                    </button>
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>

              <tbody>
                {loading && Array.from({ length: 5 }).map((_, index) => (
                  <tr key={index}>
                    <td><Skeleton height="2rem" borderRadius="1px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                    <td><Skeleton height="2rem" borderRadius="4px" /></td>
                  </tr>
                ))}
                {!loading && quicklinkList?.map((item: _Object, i: number) => (
                  <tr>
                    <td>{((filterData.page - 1) * filterData.per_page) + (i + 1)}</td>
                    <td> {item?.title || "-"}</td>
                    <td>{item?.brand_name || '-'}</td>
                    <td>{item?.offer_price || '-'}</td>
                    <td>{item?.regular_price || '-'}</td>
                    <td> {item?.description || "-"}</td>
                    <td>{item?.type || '-'}</td>
                    <td>{formatDate(item?.created_at) || '-'}</td>
                    <td>
                      <div>
                        <Button
                          icon="pi pi-pencil"
                          rounded
                          text
                          className="h-auto w-auto bg-transparent p-0 border-noround inline"
                          onClick={() => navigate(`${routes.quicklinks}/edit/${item.id}?type=${type}`)}
                          style={{ color: '#959CB6' }}
                        />
                        <Button
                          icon="pi pi-trash"
                          onClick={() => {
                            setVisible(item.id || null);
                          }}
                          rounded
                          text
                          className="h-auto w-auto bg-transparent p-0 border-noround inline"
                          style={{ color: 'var(--torch-red)' }}
                        />
                      </div>
                    </td>
                  </tr>
                ))}
                {!loading && quicklinkList?.length === 0 && <tr>
                  <td colSpan={11}>No available options</td>
                </tr>
                }
              </tbody>
            </table>
          </div>

          {!loading && pagination?.total_pages > 1 &&
            <Paginator
              first={(filterData.page - 1) * filterData.per_page}
              rows={filterData.per_page}
              totalRecords={pagination.total_items}
              rowsPerPageOptions={[10, 20, 30]}
              onPageChange={onPageChange}
            />
          }
        </div>
      </div>

      <DeleteItem
        title="QuicklinkList"
        visible={visible}
        onHide={() => setVisible(null)}
        deleteItem={() => deleteItem(visible)}
      />
    </>
  );
};

export default Quicklinks;